import { toast } from "sonner";
import { date } from "zod";
export async function getAdditionalPayments(teacherId, year, month) {
    const token = sessionStorage.getItem("token");

    if (!token) {
        toast.error("Sesión inválida. Por favor inicie sesión nuevamente.");
        throw new Error("Sesión inválida. Por favor inicie sesión nuevamente.");
    }

    try {
        const url = `${process.env.REACT_APP_API_URL}/admin/profesor/pago-adicional/listar?teacherId=${teacherId}&year=${year}&month=${month}`;

        const resp = await fetch(url, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });

        const data = await resp.json();
        const additionalPaymentsList = data.map((item) => ({
            id: item.id,
            date: item.date,
            description: item.description,
            amount: item.amount,
            teacherId: item.teacherId,
        }));
        return additionalPaymentsList;
    } catch (error) {
        toast.error('Error al obtener los profesores', error.message);
        console.error('Error al obtener los equipos:', error);
        throw error;
    }
};
